var map = {
	"./assets/avatars/anonymous_female_captain-min.png": 5601,
	"./assets/avatars/anonymous_female_captain.png": 3261,
	"./assets/avatars/anonymous_male_captain-min.png": 4597,
	"./assets/avatars/anonymous_male_captain.png": 1007,
	"./assets/avatars/captain-jack-sparrow-min.png": 4139,
	"./assets/avatars/captain-jack-sparrow.png": 941,
	"./assets/avatars/captain_crunch-min.png": 4096,
	"./assets/avatars/captain_crunch.png": 4562,
	"./assets/avatars/captain_haddock-min.png": 6075,
	"./assets/avatars/captain_haddock.png": 7184,
	"./assets/avatars/captain_hook_avatar-min.png": 5310,
	"./assets/avatars/captain_hook_avatar.png": 8436,
	"./assets/avatars/computer_avatar-min.png": 6992,
	"./assets/avatars/computer_avatar.png": 8989,
	"./assets/avatars/popeye_avatar-min.png": 3525,
	"./assets/avatars/popeye_avatar.png": 8292,
	"./assets/avatars/simson_old_sea_avatar-min.png": 115,
	"./assets/avatars/simson_old_sea_avatar.png": 9055,
	"./assets/battle_ship_background.jpg": 7966,
	"./assets/battle_ship_background.webp": 4002,
	"./assets/explosion/damage_explosion.png": 4451,
	"./assets/explosion/explosion.png": 3014,
	"./assets/explosion/explosion_sprite_2_100px.png": 3387,
	"./assets/explosion/water-splash.png": 7053,
	"./assets/favicon_battlehip.png": 4373,
	"./assets/landingImages/in_game_image001.jpg": 1237,
	"./assets/landingImages/in_game_image002.jpg": 884,
	"./assets/landingImages/in_game_image003.jpg": 3022,
	"./assets/landingImages/in_game_image004.jpg": 4013,
	"./assets/landingImages/in_game_image005.jpg": 8360,
	"./assets/landingImages/in_game_image006.jpg": 8691,
	"./assets/landingImages/in_game_image007.jpg": 6136,
	"./assets/missiles/missile_2.png": 3975,
	"./assets/missiles/missile_2_used.png": 9476,
	"./assets/ships/battleship/Battleship_FrontView_2.png": 9272,
	"./assets/ships/battleship/ShipBattleshipHull.png": 6776,
	"./assets/ships/battleship/ShipBattleshipHull_V.png": 9102,
	"./assets/ships/carrier/Carrier_FrontView_2.png": 7408,
	"./assets/ships/carrier/ShipCarrierHull.png": 838,
	"./assets/ships/carrier/ShipCarrierHull_V.png": 6192,
	"./assets/ships/destroyer/Destroyer_FrontView_2.png": 8661,
	"./assets/ships/destroyer/ShipDestroyerHull.png": 5639,
	"./assets/ships/destroyer/ShipDestroyerHull_V.png": 364,
	"./assets/ships/patrolBoat/PatrolBoat_FrontView_2.png": 5593,
	"./assets/ships/patrolBoat/ShipPatrolHull.png": 1798,
	"./assets/ships/patrolBoat/ShipPatrolHull_V.png": 1594,
	"./assets/ships/submarine/ShipSubMarineHull.png": 3587,
	"./assets/ships/submarine/ShipSubMarineHull_V.png": 379,
	"./assets/ships/submarine/Submarine_FrontView_2.png": 7794,
	"./assets/sounds/epic_music_intro.mp3": 4836,
	"./assets/sounds/game_sounds_sprite.mp3": 8865,
	"./assets/sounds/menu_music_rf.mp3": 5620,
	"./assets/sounds/music_lobby.mp3": 4491,
	"./assets/textures/metal_plates.jpg": 5694,
	"./assets/textures/metal_rivets_h.jpg": 7832,
	"./assets/textures/water_seamless.jpg": 532,
	"./assets/tutorial/cursor_AimTarget.png": 7692,
	"./assets/tutorial/hitCell.png": 7306,
	"./assets/tutorial/launchBtnSB.png": 1281,
	"./assets/tutorial/missedCell.png": 6609,
	"./assets/tutorial/spaceBar.png": 3329,
	"./assets/tutorial/timerImg.png": 9230
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7148;